import React from 'react'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { Grid, Typography, Paper, Box } from '@mui/material'
import SlickCarousel from '../control/SlickCarousel'

const useStyles = makeStyles((theme: Theme) => ({
    paper: {
        padding: theme.spacing(2),
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
    },
    subtitle1: {
        display: 'flex',
        justifyContent: 'center',
    },
    subtitle2: {
        display: 'flex',
        gap: '10px',
        justifyContent: 'center',
    },
}))

const SlickCarouselPlayground = () => {
    const classes = useStyles()
    const results = [1, 1, 1, 1]

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: true,
        draggable: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    arrows: true,
                    draggable: true,
                },
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    arrows: true,
                    draggable: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    arrows: true,
                    draggable: true,
                },
            },
            {
                breakpoint: 300,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    arrows: true,
                    draggable: true,
                },
            },
        ],
    }

    return (
        <div>
            <Typography variant="h3" gutterBottom>
                Control: Slick Carousel
            </Typography>
            <SlickCarousel settings={settings}>
                {results.map((item, index) => (
                    <Box component="div" key={index}>
                        <Paper className={classes.paper}>{index}</Paper>
                    </Box>
                ))}
            </SlickCarousel>
        </div>
    )
}

export default SlickCarouselPlayground
